import { FormControl, FormGroup } from '@angular/forms';
import { CampaignFieldTypeEnum } from '@www/_models';
import { format } from 'date-fns';

export function buildCampaignFormData(
  form: FormGroup<{
    [identifier: string]: FormGroup<{
      type: FormControl<CampaignFieldTypeEnum | null>;
      value: FormControl<any>;
      otherValue?: FormControl<string | null>;
    }>;
  }>,
) {
  const formData = new FormData();

  // fields[0][field]=UUID - unikalny identyfikator pola
  // fields[0][value]=VALUE - wartość pola
  //
  // fields[1][field]=UUID
  // fields[1][value]=binary file content - jeżeli pole to "file"
  //
  // fields[2][field]=UUID
  // fields[2][value]=1, jeżeli pole to agreement_cometition
  //
  // fields[3][field]=UUID
  // fields[3][value]=(0|1), jeżeli pole to agreement_
  //
  // fields[4][field]=UUID
  // fields[4][value]=["option 1", "option2"] - jeżeli pole to multiple_choice
  //
  // itd.

  for (const [key, value] of Object.entries(form.value)) {
    formData.append(`fields[${key}][field]`, key);
    if (
      value?.type === CampaignFieldTypeEnum.AGREEMENT_COMPETITION ||
      value?.type === CampaignFieldTypeEnum.AGREEMENT_MOBILE ||
      value?.type === CampaignFieldTypeEnum.AGREEMENT_EMAIL ||
      value?.type === CampaignFieldTypeEnum.AGREEMENT_SMS ||
      value?.type === CampaignFieldTypeEnum.AGREEMENT_WHATSAPP
    ) {
      formData.append(`fields[${key}][value]`, value.value ? '1' : '0');
    } else if (value?.type === CampaignFieldTypeEnum.FILE) {
      formData.append(`fields[${key}][value]`, value.value);
    } else if (value?.type === CampaignFieldTypeEnum.MULTIPLE_CHOICE) {
      const multipleChoiceValue = value.value as string[];
      const otherValue = value.otherValue;
      if (otherValue) {
        [...multipleChoiceValue, otherValue]
          .filter((value) => value !== 'wwwOtherValue')
          .forEach((value, index) => {
            formData.append(`fields[${key}][value][${index}]`, value);
          });
      } else {
        multipleChoiceValue.forEach((value, index) => {
          formData.append(`fields[${key}][value][${index}]`, value);
        });
      }
    } else if (value?.type === CampaignFieldTypeEnum.SINGLE_CHOICE) {
      const singleChoiceValue = value.value as string;
      const otherValue = value.otherValue;
      if (otherValue) {
        formData.append(`fields[${key}][value]`, otherValue);
      } else {
        formData.append(`fields[${key}][value]`, singleChoiceValue);
      }
    } else if (value?.type === CampaignFieldTypeEnum.BIRTHDAY) {
      // @ts-ignore
      formData.append(`fields[${key}][value]`, value.value ? format(value.value, 'yyyy-MM-dd') : '');
    } else {
      formData.append(`fields[${key}][value]`, value?.value);
    }
  }
  return formData;
}
